<template>
     <div class="conf-con">
                            <div class="intro-pic">
                                <img src="../../../assets/images/12.gif" alt="">
                            </div>
                            <p class="intro-tit">中国共产党第十二次全国代表大会简介</p>
                            <p class="margin1">1982年9月1日至11日在北京举行。出席大会的正式代表1545人，候补代表145人，代表全国3900多万名党员。邓小平致开幕词，胡耀邦作《全面开创社会主义现代化建设的新局面》的报告。邓小平在开幕词中提出了“走自己的道路，建设有中国特色的社会主义”的重要思想。大会通过的《中国共产党章程》，适应改革开放和社会主义现代化建设的需要，对党的民主集中制和各项组织制度、党的纪律作了更充分、更具体的规定。大会通过了《关于十一届中央委员会报告的决议》、《关于〈中国共产党章程〉的决议》和《关于中央纪律检查委员会工作报告的决议》。大会选举了由210名委员和138名候补委员组成的中央委员会，选举了由172名委员组成的中央顾问委员会和由132名委员组成的中央纪律检查委员会。随后召开的十二届一中全会选举了中央政治局及其常务委员会；选举胡耀邦为中央委员会总书记；决定邓小平为中央军事委员会主席。批准邓小平为中央顾问委员会主任，陈云为中央纪律检查委员会第一书记。
                            </p>
                        </div>
</template>

<script>
export default {

}
</script>

<style>

</style>